export class MemberDto {
  _id: string;
  status: Status;
  userType: UserType;
  email: string;
  brazeId: string;
  airtableId: string;
  customerId: string;
  passwordHash: string | null;
  createdAt: Date;
  updatedAt: Date | null;
  referralCode: string;
  isPasswordSet: boolean;
  onboardingSettings: Partial<OnboardingSettings>;
  profile: Partial<MemberProfile>;
  freePassportFeeExpirationDate: string;
  subscription: UserSubscription;
}

export type UserSubscription = {
  productId: string;
  productName: string;
};

export type OnboardingSettings = {
  referredBy: Pick<MemberDto, 'referralCode'>;
  expediteCode: string;
  promoCode: string;
  howYouKnowAboutUs: HowYouKnowAboutUs;
  otherText: string;
  expediteBy?: Partial<MemberProfile>
};

export enum Status {
  NEW = 'new',
  AWAITING_REVIEW = 'awaiting_review',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PAST_DUE = 'past_due',
  PAUSED = 'paused',
  WAITLIST = 'waitlist',
}

export type MemberProfile = {
  firstName?: string;
  lastName?: string;
  birthday?: string;
  countryOfResidence?: string;
  secondaryCities?: string[];
  industry?: string;
  linkedin?: string;
  instagram?: string;
  travelStory?: string;
  aboutMe?: string;
  perfectDay?: string;
  excitesyou?: string[];
  address?: string;
  gender?: string;
  ethnicity?: string;
  website?: string;
  interestedInSpaces?: string[];
  whyInterested?: string;
  howOftenEngage?: string;
  interestedInMemberEvents?: string;
  newsletter?: boolean;
  howYouKnowAboutUs?: HowYouKnowAboutUs;
  howYouKnowAboutUsOtherText?: string; 
  howOftenEngageOtherText?: string; 
  phoneNumber?: string;
  membershipPreference?: {
    startDate: string;
    recurring: string;
    subscriptionId: string;
    priceId: string;
    joiningFee: number;
    isSubscriptionLocked: boolean;
    isPriceLocked: boolean;
  };
};

export enum UserType {
  MEMBER = 'member',
  PARTNER = 'partner',
  ADMIN = 'admin',
  ACCOUNT = 'account',
  CHECK_IN = 'check-in',
}

export enum HowYouKnowAboutUs {
  REFERRAL = 'referral',
  YAYEM_EXPERIENCE = 'yayem_experience',
  AETHOS_EXPERIENCE = 'aethos_experience',
  INSTAGRAM = 'instagram',
  OTHER = 'other',
  GOOGLE = 'google',
  WEBSITE = 'website',
  SOCIAL = 'social',
  EVENT = 'event',
  FRIEND = 'friend',
}

export type HowYouKnowAboutUsType = {
  userId?: string;
  howYouKnowAboutUs?: HowYouKnowAboutUs;
  referralCode?: string;
  otherText?: string;
};

export type reApplyMemberType = {
  reApplyMessage: string;
};
